import { styled } from '@mui/material/styles'
import { StyledButton } from './StyledButton'
import { ButtonProps } from '@mui/material'
import { buttonColorMap } from './buttonColorMap'

import { LinkProps as RouterLinkProps } from 'react-router-dom'

export type ToolbarButtonProps = Omit<ButtonProps, 'component'> &
    RouterLinkProps

export const ToolbarButton = styled(StyledButton, {
    shouldForwardProp: (prop) =>
        prop !== 'dense' && prop !== 'modalized' && prop !== 'sx',
})<ToolbarButtonProps>(({ theme, dense }) => {
    return {
        height: dense ? 32 : 42,
        minWidth: dense ? 32 : 42,

        '& .MuiButton-endIcon > svg': {
            fontSize: dense ? '0.875rem' : undefined,
        },

        '& .MuiButton-startIcon > svg': {
            fontSize: dense ? '0.875rem' : undefined,
        },
    }
})
